( function( $, document, window ) {
	'use strict';

	function combineClass( className, blockId ) {
		return `${className}-${blockId}`;
	}

	$( function() {
		$( '.js-image-gallery' ).each( function() {

			const blockId = this.dataset.blockId;

			const config = {
				activeClass: 'is-active',
				carouselEl: combineClass( '.js-carousel', blockId ),
				paginationEl: combineClass( '.js-carousel-pagination', blockId ),
				navigationEl: combineClass( '.js-carousel-navigation', blockId ),
				prevEl: combineClass( '.js-carousel-navigation-prev', blockId ),
				nextEl: combineClass( '.js-carousel-navigation-next', blockId ),
			};

			const controls = this.querySelectorAll( `${config.paginationEl}, ${config.navigationEl}` );

			const controlsVisibility = function () {
				if ( this.pagination.bullets.length > 1 ) {
					controls.forEach( function ( element ) {
						element.classList.add( config.activeClass );
					} );
				} else {
					controls.forEach( function ( element ) {
						element.classList.remove( config.activeClass );
					} );
				}
			};

			new Swiper( config.carouselEl, {
				direction: 'horizontal',
				spaceBetween: 10,
				slidesPerView: 'auto',
				loop: true,
				watchOverflow: true,

				navigation: {
					prevEl: config.prevEl,
					nextEl: config.nextEl,
				},

				pagination: {
					el: config.paginationEl,
					clickable: true,
				},

				breakpoints: {
					768: {
						spaceBetween: 20,
						slidesPerView: 2,
					},
					1280: {
						spaceBetween: 20,
						slidesPerView: 2,
					},
					1400: {
						spaceBetween: 40,
						slidesPerView: 2,
					}
				},

				on: {
					init: controlsVisibility,
					resize: controlsVisibility

				}
			});
		} );
	} );
} )( jQuery, document, window );
